export default class Searchbar {

    constructor($view) {
        this.$view = $view;
        this.$div = this.$view.find("#search-picto-container");
        this.$inputContent  =this.$view.find("#searchField");
        this.$content = null;
        this.bind();
    }

    bind() {

        // on recupere le contenu de linput
       this.$inputContent.on("input", function (e){
         this.$content =  e.currentTarget.value;
       });

        // gestion de la barre de recherche en responsive
        this.$div.on("click",  (e) =>{
            e.preventDefault();
            window.location = "/recherche/" + this.$content + "?type=produits";
            return false;
        });
    }
}


// WEBPACK FOOTER //
// ./public/frontend/js/components/Searchbar.js